export var staplesTheme = {
    colors: {
        primary: "#CC0000",
        secondary: "#000",
        white: "#FFF",
        black: "#000",
        grayDarker: "#444444",
        grayDark: "#A1A1A1",
        gray: "#E9E9E9",
        grayLight: "#F3F3F3",
    },
    typography: {
        bodyColor: "#000",
        fontFamily: "Roboto, 'neue-haas-grotesk-display', sans-serif",
        fontSize: "100%",
        title: {
            fontSize: 75,
            fontSizeTablet: 75,
            fontSizeMobile: 48,
            lineHeight: "1.2",
            fontWeight: "bold",
        },
        heading2: {
            fontSize: 60,
            fontSizeTablet: 48,
            fontSizeMobile: 40,
            lineHeight: "1.2",
            fontWeight: "bold",
        },
        heading3: {
            fontSize: 40,
            fontSizeTablet: 24,
            fontSizeMobile: 24,
            lineHeight: "1.2",
            fontWeight: "bold",
        },
        heading4: {
            fontSize: 32,
            fontSizeTablet: 32,
            fontSizeMobile: 24,
            lineHeight: "1.2",
            fontWeight: "bold",
        },
        heading5: {
            fontSize: 32,
            fontSizeTablet: 32,
            fontSizeMobile: 40,
            lineHeight: "1.2",
            fontWeight: "normal",
        },
        heading6: {
            fontSize: 24,
            fontSizeTablet: 24,
            fontSizeMobile: 24,
            lineHeight: "1.2",
            fontWeight: "normal",
        },
        body: {
            fontSize: 16,
            fontSizeTablet: 16,
            fontSizeMobile: 16,
            lineHeight: "1.5",
            fontWeight: "normal",
        },
    },
};
